
import React from 'react';
import { FaMapMarkerAlt, FaPhone, FaWhatsapp, FaAccessibleIcon, FaUtensils, FaUserFriends, FaMusic, FaTree, FaSwimmer } from 'react-icons/fa';
import Gallery from '../components/Gallery';
import glew_frente_nuevo from '../assets/img/glew/glew_frente_nuevo.png'

const gtag_report_conversion = (url) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'conversion', {
      'send_to': 'AW-16956303663/FXqBCP_4gNcaEK_SspU_',
      'event_callback': function () {
        if (typeof(url) !== 'undefined') {
          window.location = url;
        }
      }
    });
  } else {
    window.location = url;
  }
};


const Glew = () => {
  // Imágenes para la galería (en producción se reemplazarían por imágenes reales)
  const galleryImages = [
    { src: 'https://images.unsplash.com/photo-1543269865-cbf427effbad', alt: 'Centro Glew - Actividades' },
    { src: 'https://images.unsplash.com/photo-1564951434112-64d74cc2a2d7', alt: 'Centro Glew - Instalaciones' },
    { src: 'https://images.unsplash.com/photo-1607453998774-d533f65dac99', alt: 'Centro Glew - Exterior' },
    { src: 'https://images.unsplash.com/photo-1607453998774-d533f65dac99', alt: 'Centro Glew - Terapia' }
  ];

  return (
    <div className="container">
      <div className="sede-header">
        <h1>Sede Glew</h1>
        <p>Nuestra sede de Glew ofrece un espacio amplio y naturaleza circundante para el desarrollo de nuestras actividades terapéuticas.</p>
      </div>

      <section className="sede-info">
        <div className="sede-details">
          <h2>Sobre nuestra sede</h2>
          <p>La sede de Glew se inauguró como una expansión de Mi Lugar para brindar nuestros servicios a más familias de la zona sur. Ubicada en un entorno más rural, esta sede cuenta con amplios espacios verdes que permiten realizar actividades al aire libre y terapias en contacto con la naturaleza.</p>
          <p>Nuestras instalaciones en Glew están completamente adaptadas y equipadas con todos los recursos necesarios para brindar atención de calidad, en un ambiente tranquilo y estimulante.</p>

          <div className="sede-contact">
            <h3>Información de contacto</h3>
            <div className="contact-item">
              <FaMapMarkerAlt className="contact-icon" />
              <span>RP210 Nº 22548, Glew - Provincia de Buenos Aires</span>
            </div>
            <div className="contact-item">
              <FaPhone className="contact-icon" />
              <span>1165661677</span>
            </div>
          </div>

          <div className="sede-buttons" style={{ marginTop: '20px' }}>
            <a href="https://wa.me/5491165661677" className="btn btn-whatsapp" target="_blank" rel="noopener noreferrer">
              <FaWhatsapp /> Contactar por WhatsApp
            </a>
          </div>
        </div>

        <div className="sede-image">
          <img src= {glew_frente_nuevo} alt="Sede Glew" />
        </div>
      </section>

      <section className="sede-facilities">
        <h2 className="section-title">Nuestras instalaciones</h2>
        <div className="facilities-grid">
          <div className="facility-item">
            <FaAccessibleIcon className="facility-icon" />
            <div>
              <h3>Accesibilidad total</h3>
              <p>Instalaciones adaptadas para movilidad reducida</p>
            </div>
          </div>
          <div className="facility-item">
            <FaUtensils className="facility-icon" />
            <div>
              <h3>Comedor</h3>
              <p>Servicio de alimentación supervisado</p>
            </div>
          </div>
          <div className="facility-item">
            <FaUserFriends className="facility-icon" />
            <div>
              <h3>Salas terapéuticas</h3>
              <p>Espacios especializados para cada terapia</p>
            </div>
          </div>
          <div className="facility-item">
            <FaMusic className="facility-icon" />
            <div>
              <h3>Sala de música</h3>
              <p>Equipada para musicoterapia</p>
            </div>
          </div>
          <div className="facility-item">
            <FaTree className="facility-icon" />
            <div>
              <h3>Amplios espacios verdes</h3>
              <p>Áreas naturales para actividades recreativas</p>
            </div>
          </div>
          <div className="facility-item">
            <FaSwimmer className="facility-icon" />
            <div>
              <h3>Actividades al aire libre</h3>
              <p>Programas de estimulación en contacto con la naturaleza</p>
            </div>
          </div>
        </div>
      </section>

      <section>
        <h2 className="section-title">Galería de fotos</h2>
        <Gallery images={galleryImages} />
      </section>

      <section className="map-container">
        <h2 className="section-title">¿Cómo llegar?</h2>
        <p>Estamos ubicados en RP210 Nº 22548, Glew, Provincia de Buenos Aires.</p>
        <div style={{ marginTop: '20px' }}>
          <a 
            href="https://www.google.com/maps/search/?api=1&query=RP210+22548,+Glew,+Buenos+Aires" 
            className="btn"
            target="_blank" 
            rel="noopener noreferrer"
          >
            <FaMapMarkerAlt /> Ver en Google Maps
          </a>
        </div>
        <div style={{ marginTop: '30px', height: '400px' }}>
          <iframe 
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3278.1!2d-58.4!3d-34.9!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzTCsDU0JzAwLjAiUyA1OMKwMjQnMDAuMCJX!5e0!3m2!1ses!2sar!4v1634567890123!5m2!1ses!2sar" 
            width="100%" 
            height="100%" 
            style={{ border: 0, borderRadius: '8px' }} 
            allowFullScreen="" 
            loading="lazy"
            title="Mapa Sede Glew"
          ></iframe>
        </div>
      </section>

       {/* WhatsApp Float Button With Report*/}
      <a
        href="#"
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => {
          e.preventDefault();
          gtag_report_conversion("https://wa.me/5491165651677");
        }}
      >
        <FaWhatsapp />
      </a>
    </div>
  );
};

export default Glew;
